// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

const faq = {
  hd: {
    question: "В чем заключается польза для сотрудников?",
    answer: "В настоящее время актуальной является проблема кредитов или займов “до зарплаты”. Сотрудники предприятий берут кредиты и займы в надежде быстро решить свои финансовые вопросы или покрыть непредвиденные расходы. Сервис позволяет сотрудникам моментально получить аванс на карту в любой день и в любое время суток."
  },
  tl: {
    hd: {
      question: "Какая польза для работодателя?",
      answer: "Работники предприятий больше не будут приходить к вам с просьбой выплатить аванс. Ваши сотрудники будут знать, что за каждый отработанный день они смогут получить свои деньги в любое время. В результате вы получите сконцентрированных, замотивированных на выполнение работы сотрудников и сократите текучку кадров."
    },
    tl: {
      hd: {
        question: "Как подключение к сервису отразится на работе бухгалтерии?",
        answer: "Если до подключения к сервису выплата аванса требовала заполнения бумажек в бухгалтерии и отправления платежных поручений, то после подключения бухгалтер не будет тратить свое рабочее время на выплату авансов."
      },
      tl: {
        hd: {
          question: "Интеграция",
          answer: "Бухгалтеру не потребуется вручную вводить в 1С, Oracle, SAP каждую проведенную транзакцию по выводу авансов. Благодаря интеграции с 1С, Oracle, SAP все операции автоматически будут подгружаться в программу, что значительно сэкономит время вашего бухгалтера."
        },
        tl: /* [] */ 0
      }
    }
  }
};

function Payroll(Props) {
  const intl = ReactIntl.useIntl();
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = React.useState(function () {
    return /* [] */ 0;
  });
  const setIdxes = match[1];
  const idxes = match[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: "Автоматическая выплата заработной платы сотрудникам",
            className: "h3 lg:h1 lg:w-252 text-center lg:m-auto text-white"
          }),
          JsxRuntime.jsx("h5", {
            children: "Ваши сотрудники смогут отслеживать заработанные деньги и снимать в любое удобное время",
            className: "paragraph-large lg:h5 text-center lg:w-220 lg:m-auto mt-4 lg:mt-6 text-white"
          }),
          JsxRuntime.jsx("hr", {
            className: "mt-16 lg:mt-20 w-full lg:w-200 opacity-8"
          }),
          JsxRuntime.jsx("img", {
            className: "mt-16 lg:mt-20 w-full lg:w-252 lg:h-120",
            alt: "ewa",
            src: StaticAsset.src(deviceType === "mobile" ? "/static/images/ewa-mobile.png" : "/static/images/ewa.png")
          })
        ],
        className: "bg-black-landing pt-16 lg:pt-40 flex flex-col items-center w-full px-6 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-8 h-8",
                    alt: "calendar black",
                    src: StaticAsset.src("/static/icons/calendar-black-32.svg")
                  }),
                  JsxRuntime.jsx("h4", {
                    children: "Круглосуточно, без выходных и праздничных дней",
                    className: "h6 lg:h4"
                  })
                ],
                className: "flex gap-4 items-center lg:items-start"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-8 h-8",
                    alt: "paper plane black",
                    src: StaticAsset.src("/static/icons/paper-plane-black-32.svg")
                  }),
                  JsxRuntime.jsx("h4", {
                    children: "Моментальный расчет и учет",
                    className: "h6 lg:h4"
                  })
                ],
                className: "flex gap-4 mt-8 lg:mt-16 items-center lg:items-start"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-8 h-8",
                    alt: "handshake black",
                    src: StaticAsset.src("/static/icons/handshake-black-32.svg")
                  }),
                  JsxRuntime.jsx("h4", {
                    children: "Не требует ручной работы бухгалтера",
                    className: "h6 lg:h4"
                  })
                ],
                className: "flex gap-4 mt-8 lg:mt-16 items-center lg:items-start"
              })
            ],
            className: "lg:w-92"
          }),
          JsxRuntime.jsx("img", {
            className: "w-full lg:w-140 lg:h-112 mt-10 lg:mt-0",
            alt: "ewa",
            src: StaticAsset.src("/static/images/ewa2.png")
          })
        ],
        className: "flex flex-col lg:flex-row pt-10 lg:pt-38 lg:justify-center lg:gap-8 lg:items-center px-6"
      }),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "flex m-auto mt-10 lg:mt-32",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "start_using"),
        onClick: (function (param) {
          Buhta_landing__EventHandlers.scrollToFooter(deviceType);
        })
      }),
      JsxRuntime.jsx("p", {
        children: "Уже подключены 17 компаний и 9 000+ сотрудников",
        className: "paragraph-small text-center text-gray-landing mt-4"
      }),
      JsxRuntime.jsx("h2", {
        children: "Зачем это нужно компаниям",
        className: "h4 lg:h2 mt-20 lg:mt-30 lg:text-center px-6 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-14 h-14",
                alt: "target",
                src: StaticAsset.src("/static/icons/target.svg")
              }),
              JsxRuntime.jsx("h5", {
                children: "Повышает лояльность сотрудников",
                className: "h6 lg:h5 mt-4 lg:mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "Сотрудники остаются с работодателями, которые платят зарплату своевременно",
                className: "paragraph lg:paragraph-large mt-2 lg:mt-4 text-gray-landing"
              })
            ],
            className: "lg:w-78.75"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-14 h-14",
                alt: "abacus blue",
                src: StaticAsset.src("/static/icons/abacus-blue-56.svg")
              }),
              JsxRuntime.jsx("h5", {
                children: "Снижает затраты на бухгалтерию",
                className: "h6 lg:h5 mt-4 lg:mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "Не нужно нанимать отдельного бухгалтера, все работает автоматически",
                className: "paragraph lg:paragraph-large mt-2 lg:mt-4 text-gray-landing"
              })
            ],
            className: "mt-8 lg:mt-0 lg:w-78.75"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-14 h-14",
                alt: "stonk blue",
                src: StaticAsset.src("/static/icons/stonk-blue-56.svg")
              }),
              JsxRuntime.jsx("h5", {
                children: "Упрощает бизнес процессы",
                className: "h6 lg:h5 mt-4 lg:mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "При подключении сервиса, настройте все под свой бизнес и не нужно будет возвращаться без необходимости",
                className: "paragraph lg:paragraph-large mt-2 lg:mt-4 text-gray-landing"
              })
            ],
            className: "mt-8 lg:mt-0 lg:w-78.75"
          })
        ],
        className: "mt-10 lg:mt-20 lg:flex lg:gap-8 lg:justify-center px-6"
      }),
      JsxRuntime.jsx("h2", {
        children: "Адаптируем решение под особенности вашего бизнеса",
        className: "h4 lg:h2 mt-20 lg:mt-30 text-center lg:w-200 px-6 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-full lg:w-96 lg:h-110",
            alt: "jumis",
            src: StaticAsset.src(deviceType === "mobile" ? "/static/images/jumis-mobile.png" : "/static/images/jumis.png")
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "«Бухта помогает нам автоматизированно выплачить ежедневные авансы сотрудникам за фактически отработанные дни и даже сотрудникам, которые работают удаленно».",
                className: "paragraph lg:paragraph-large text-white text-center"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("h4", {
                      children: "JB",
                      className: "h4 text-white"
                    }),
                    className: "rounded-full w-14 h-14 flex items-center justify-center mt-8 lg:mt-0 bg-[#382C2C]"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Jumis Bar ･ Директор",
                    className: "paragraph-small text-white mt-4"
                  })
                ],
                className: "flex flex-col items-center"
              })
            ],
            className: "flex flex-col w-full items-center py-10 px-6 lg:px-10 justify-between"
          })
        ],
        className: "mt-8 lg:mt-16 bg-brown lg:flex lg:w-200 mx-6 lg:mx-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Подключите выплаты вашим сотрудникам",
                className: "h4 lg:h2 text-center lg:text-left"
              }),
              JsxRuntime.jsx("p", {
                children: "Зарегистрируйтесь или обратитесь в раздел \"Помощь\"",
                className: "paragraph lg:paragraph-large opacity-64 mt-2 text-center lg:text-left"
              }),
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                classes: {
                  hd: "flex m-auto lg:m-0 mt-6 lg:mt-10",
                  tl: /* [] */ 0
                },
                label: Buhta_landing__I18n.trans(intl, "start_using"),
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              })
            ],
            className: "lg:w-130 px-6 lg:px-0"
          }),
          JsxRuntime.jsx("img", {
            className: "mt-14 lg:mt-0 w-full lg:w-136 lg:h-110.75",
            alt: "ewa",
            src: StaticAsset.src("/static/images/ewa3.png")
          })
        ],
        className: "w-full mt-10 lg:mt-30 pt-10 lg:flex lg:justify-center lg:items-center bg-[#E4E6EB]"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Ответы на часто задаваемые вопросы",
            className: "h4 lg:h3 text-black-landing mb-6 lg:mb-16 lg:w-120"
          }),
          Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, d) {
            const Key = "faq_" + String(i);
            return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("h6", {
                      children: d.question,
                      className: "h6 text-black-landing"
                    }),
                    Stdlib__List.exists((function (idx) {
                      return idx === i;
                    }), idxes) ? JsxRuntime.jsx("img", {
                        className: "shrink-0",
                        src: StaticAsset.src("/static/icons/minus.svg")
                      }) : JsxRuntime.jsx("img", {
                        className: "shrink-0",
                        src: StaticAsset.src("/static/icons/plus-black.svg")
                      })
                  ],
                  className: "flex justify-between py-4 border-b border-divider items-center cursor-pointer",
                  onClick: (function (param) {
                    if (Stdlib__List.exists((function (idx) {
                        return idx === i;
                      }), idxes)) {
                      return Curry._1(setIdxes, (function (state) {
                        return Stdlib__List.filter((function (item) {
                          return item !== i;
                        }), state);
                      }));
                    } else {
                      return Curry._1(setIdxes, (function (state) {
                        return Stdlib__List.append(state, {
                          hd: i,
                          tl: /* [] */ 0
                        });
                      }));
                    }
                  })
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("p", {
                    children: d.answer,
                    className: "paragraph text-gray-landing whitespace-pre-line"
                  }),
                  className: Cn.fromList({
                    hd: "border-b border-divider py-6",
                    tl: {
                      hd: Stdlib__List.exists((function (idx) {
                        return idx === i;
                      }), idxes) ? "block" : "hidden",
                      tl: /* [] */ 0
                    }
                  })
                })
              ]
            }, Key);
          }), faq))
        ],
        className: "flex m-auto flex-col py-10 sm:py-20 lg:py-30 px-6 sm:px-48 lg:px-0 lg:w-148"
      })
    ],
    className: "text-black flex flex-col items-center"
  });
}

const make = Payroll;

export {
  faq,
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
